import React from "react";
import "./DatePicker.css";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const DatePicker = ({
  label,
  name,
  value,
  onChange,
  minDate = "",
  maxDate = "",
  parentClassName = "",
  inputClassName = "",
  labelClassName = "",
  placeholder = "Enter date",
  parentStyle = {},
  inputStyle = {},
  labelStyle = {},
  readOnly = false,
  disabled = false,
  required = false,
  autocomplete = "off",
  customError,
  asterisk,
}) => {
  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-date-piker-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-date-piker-label-class"
        }
        style={labelStyle}>
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="date-piker-input-wrapper">
        <input
          type="date"
          name={name}
          value={value}
          onChange={onChange}
          min={minDate}
          max={maxDate}
          placeholder="DD/MM/YYYY"
          className={`${
            inputClassName && inputClassName.trim() !== ""
              ? inputClassName
              : "default-date-piker-input-class"
          } ${customError ? "date-piker-input-error" : ""}`}
          style={{ ...inputStyle, textTransform: "uppercase" }}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          autocomplete={autocomplete}
        />
        {customError && (
          <i className="fas fa-exclamation-circle date-piker-error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default DatePicker;
